<template>

    <div>
        <header>
            <h2 v-if="editing === true">{{ lang('all.adres_wijzigen') }}</h2>
            <h2 v-else>{{ lang('all.adres_toevoegen') }}</h2>
        </header>

        <text-input
            :label="lang('all.bedrijfsnaam_optioneel')"
            v-model="form.companyname"
            :errors="errors.companyname"
        ></text-input>

        <div class="row">
            <div class="col-6">
                <text-input
                    :label="lang('all.voornaam')"
                    v-model="form.firstname"
                    :errors="errors.firstname"
                ></text-input>
            </div>
            <div class="col-6">
                <text-input
                    :label="lang('all.achternaam')"
                    v-model="form.lastname"
                    :errors="errors.lastname"
                ></text-input>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <text-input
                    :label="lang('all.straat')"
                    v-model="form.street"
                    :errors="errors.street"
                ></text-input>
            </div>
            <div class="col-3">
                <text-input
                    :label="lang('all.huisnummer')"
                    v-model="form.housenr"
                    :errors="errors.housenr"
                ></text-input>
            </div>
            <div class="col-3">
                <text-input
                    :label="lang('all.toevoeging')"
                    v-model="form.housenrext"
                    :errors="errors.housenrext"
                ></text-input>
            </div>
        </div>

        <div class="row">
            <div class="col-2">
                <text-input
                    :label="lang('all.postcode')"
                    v-model="form.zipcode"
                    :errors="errors.zipcode"
                ></text-input>
            </div>
            <div class="col-5">
                <text-input
                    :label="lang('all.plaats')"
                    v-model="form.city"
                    :errors="errors.city"
                ></text-input>
            </div>
            <div class="col-5">
                <div class="form-group">
                    <label for="country_id" class="control-label">{{ lang('all.land') }}</label>
                    <vue-select
                        class="vselect-box"
                        id="country_id"
                        v-model="form.country_id"
                        :clearable="false"
                        :options="countries.data"
                        :reduce="country => country.uuid"
                        :label="lang('all.name')"
                    ></vue-select>
                </div>
            </div>
        </div>

        <div>

            <button
                type="button"
                class="btn btn-primary"
                @click="onSubmit"
            >
                {{ lang('all.adres_opslaan') }}
            </button>
        </div>
    </div>

</template>

<script>

import vueSelect from 'vue-select';
import MyAccountLayout from "../../../../Shared/Auth/MyAccount/Layout";
import TextInput from "../../../../Common/TextInput";

export default {

    components: {
        vueSelect,
        TextInput,
    },

    computed: {
        editing() {
            if (!this.address) {
                return false;
            }
            return Object.keys(this.address).length > 0;
        },

        errors() {
            return this.$page.props.errors;
        },

        getPostdata() {
            return this.form;
        },

        getRoute() {
            return this.editing === true ?
                this.route('auth.myaccount.addresses.edit', {uuid: this.address.data.uuid}) :
                this.route('auth.myaccount.addresses.store');
        },
    },

    data() {
        return {
            form: {
                companyname:'',
                firstname:'',
                lastname:'',
                street:'',
                housenr:'',
                housenrext:'',
                city:'',
                zipcode:'',
                country_id:null,
            }
        }
    },

    layout:MyAccountLayout,

    metaInfo() {
        return {
            title: 'Adres ' + (this.editing ? 'bewerken' : 'toevoegen'),
        }
    },

    methods: {
        onSubmit() {
            this.$inertia.post(this.getRoute, this.getPostdata);
        },

        setFormData() {
            this.form = JSON.parse(JSON.stringify(this.address.data));
        },
    },

    mounted(){
        if (this.editing === true) {
            this.setFormData();
        } else {
            this.form.country_id = 'dbf3d6e6-92a2-45c5-8a20-37ba3f6acd8e';
        }
    },

    name:'AuthMyAccountAddressesForm',

    props: {
        address: {
            type:Object,
            default: () => {},
        },
        countries: {
            type:Object,
            required:true,
        },
    },

}

</script>
